import { Component } from '@angular/core';

@Component({
  selector: 'app-application-svg',
  standalone: true,
  imports: [],
  templateUrl: './application-svg.component.html',
  styleUrl: './application-svg.component.scss'
})
export class ApplicationSvgComponent {

  downloadApplicationLink(): void {
    window.open('https://onelink.to/3b37h4', '_blank')
  }

}
